import React from 'react'
import styled from 'styled-components'
import NavItem from './NavItem'
import { media } from '../styles/vars'

const Container = styled.ul`
background-color:rgba(0, 0, 0, .8);
padding:10px;
text-align:center;
height:100%;
${
    media.desktop`
    border-bottom-right-radius:7px;
    `
    }
`

const NavList = (props) => {
    return (
        <Container>
            {
                props.items.map((item, idx) =>
                    <NavItem
                        key={idx}
                        title={item.title}
                        href={item.href}
                        type={item.type}
                        target={item.target}
                        noScroll={props.noScroll}
                        onClick={props.onItemClick}
                        isMobile={props.isMobile}
                    />
                )
            }
        </Container>
    )
}

export default NavList;


// WEBPACK FOOTER //
// ./src/components/NavList.jsx